import { ReactNode, useState } from 'react'
import Markdown from 'react-markdown'
import content from '../../content/banner'
import './Banner.css'

const { markdown } = content
const ALLOWED_ELEMENTS = ['a', 'p', 'strong', 'em', 'br']

export const LinkComponent = (props: {
  children?: ReactNode
  href?: string
}) => {
  return (
    <a href={props.href} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  )
}

const Banner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(true)

  const handleOnClose = () => {
    setShowBanner(false)
    sessionStorage.setItem('hide-qhack-banner', JSON.stringify(true))
  }

  const isInStorage = () => {
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('hide-qhack-banner') === null
    } else return null
  }

  if (!markdown || !isInStorage() || !showBanner) return null

  return (
    <div className="Banner" data-testid="banner">
      <div className="Banner__container">
        <div className="Banner__text">
          <Markdown
            allowedElements={ALLOWED_ELEMENTS}
            components={{ a: LinkComponent }}
          >
            {markdown}
          </Markdown>
        </div>
        <button
          aria-label="close banner"
          className="Banner__close"
          onClick={handleOnClose}
          data-testid="close-banner-button"
        >
          <i className="bx bx-x"></i>
        </button>
      </div>
    </div>
  )
}

export default Banner
